import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { QUESTION_TYPE_LABELS } from '../../constants';
import { QuestionType } from '../../types';

import type { FieldError } from 'react-hook-form';

interface QuestionAnswerTypeFieldProps {
    questionId: string;
    questionType: QuestionType;
    index: number;
    fieldIndex?: number;
    error?: FieldError;
    onChange: (newType: QuestionType) => void;
}

/**
 * Select component for choosing question answer type.
 */
const QuestionAnswerTypeField: React.FC<QuestionAnswerTypeFieldProps> = (props) => {
    const { index, fieldIndex, error, onChange } = props;
    const formContext = useFormContext();

    const labelId = `answer-type-label-${index}`;
    const selectId = `answer-type-${index}`;

    return (
        <FormControl size="small" fullWidth error={!!error}>
            <InputLabel id={labelId}>Answer type</InputLabel>
            <Controller
                name={`questions.${fieldIndex}.type` as const}
                control={formContext.control}
                render={({ field }) => (
                    <Select
                        {...field}
                        labelId={labelId}
                        id={selectId}
                        label="Answer type"
                        onChange={(e) => {
                            const newType = e.target.value as QuestionType;
                            field.onChange(newType);
                            onChange(newType);
                        }}
                    >
                        {Object.values(QuestionType).map((type) => (
                            <MenuItem key={type} value={type}>
                                {QUESTION_TYPE_LABELS[type]}
                            </MenuItem>
                        ))}
                    </Select>
                )}
            />
            {error && <FormHelperText>Answer type is required</FormHelperText>}
        </FormControl>
    );
};

export default React.memo(QuestionAnswerTypeField);
